<template>
    <jet-form-section @submitted="updateCustomerInformation">
        <template #title>
            Kundendaten
        </template>

        <template #description>
            Aktualisieren Sie hier Ihre B2B Kundeninformationen.
        </template>

        <template #form>
            <!-- Team Owner Information -->
            <div class="col-span-6">
                <jet-label value="Verwalter des Teams" />

                <div class="flex items-center mt-2">
                    <!-- <img class="w-12 h-12 rounded-full object-cover" :src="team.owner.profile_photo_url" :alt="team.owner.name"> -->

                    <div class="leading-tight">
                        <div>{{ team.owner.name }}</div>
                        <div class="text-gray-700 text-sm">{{ team.owner.email }}</div>
                    </div>
                </div>
            </div>

            <!-- Customer data -->
            <div class="col-span-6 sm:col-span-4">
                <jet-label for="company_name" value="Firmenname" />
                <jet-input id="company_name" type="text" class="mt-1 block w-full" v-model="form.company_name" autocomplete="company_name" />
                <jet-input-error :message="form.errors.company_name" class="mt-2" />
            </div>
            <div class="col-span-6 sm:col-span-2">
                <jet-label for="customer_nr" value="Kundenummer" />
                <jet-input id="customer_nr" disabled type="text" class="mt-1 opacity-40 block w-full" v-model="form.customer_nr" autocomplete="customer_nr" />
                <jet-input-error :message="form.errors.customer_nr" class="mt-2" />
            </div>
            <div class="col-span-6 sm:col-span-2">
                <jet-label for="street" value="Straße" />
                <jet-input id="street" type="text" class="mt-1 block w-full" v-model="form.street" autocomplete="street" />
                <jet-input-error :message="form.errors.street" class="mt-2" />
            </div>
            <div class="col-span-6 sm:col-span-1">
                <jet-label for="street_nr" value="Nr." />
                <jet-input id="street_nr" type="text" class="mt-1 block w-full" v-model="form.street_nr" autocomplete="street_nr" />
                <jet-input-error :message="form.errors.street_nr" class="mt-2" />
            </div>
            <div class="col-span-6 sm:col-span-1">
                <jet-label for="postcode" value="PLZ" />
                <jet-input id="postcode" type="text" class="mt-1 block w-full" v-model="form.postcode" autocomplete="postcode" />
                <jet-input-error :message="form.errors.postcode" class="mt-2" />
            </div>
            <div class="col-span-6 sm:col-span-2">
                <jet-label for="city" value="Stadt" />
                <jet-input id="city" type="text" class="mt-1 block w-full" v-model="form.city" autocomplete="city" />
                <jet-input-error :message="form.errors.city" class="mt-2" />
            </div>
        </template>

        <template #actions>
            <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                Gespeichert.
            </jet-action-message>

            <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Speichern
            </jet-button>
        </template>
    </jet-form-section>
</template>

<script>
    import JetButton from '@/Jetstream/Button'
    import JetFormSection from '@/Jetstream/FormSection'
    import JetInput from '@/Jetstream/Input'
    import JetInputError from '@/Jetstream/InputError'
    import JetLabel from '@/Jetstream/Label'
    import JetActionMessage from '@/Jetstream/ActionMessage'
    import JetSecondaryButton from '@/Jetstream/SecondaryButton'

    export default {
        components: {
            JetActionMessage,
            JetButton,
            JetFormSection,
            JetInput,
            JetInputError,
            JetLabel,
            JetSecondaryButton,
        },

        props: ['customer', 'team'],

        data() {
            return {
                form: this.$inertia.form({
                    _method: 'PUT',
                    // customer_nr: this.customer ? this.customer.customer_nr : '',
                    company_name: this.team ? this.team.company_name : '',
                    street: this.team ? this.team.street : '',
                    street_nr: this.team ? this.team.street_nr : '',
                    postcode: this.team ? this.team.postcode : '',
                    city: this.team ? this.team.city : '',
                }),
            }
        },

        methods: {
            updateCustomerInformation() {
                if (this.$refs.photo) {
                    this.form.photo = this.$refs.photo.files[0]
                }

                this.form.post(route('custom.user-customer-information.update'), {
                    errorBag: 'updateCustomerInformation',
                    preserveScroll: true
                });
            },
        },
    }
</script>
